import { Box } from '@mui/material'
import Phase1MessageContent from '@/components/Phase1/Phase1MessageContent'
import Phase1ResponseText from '@/components/Phase1/Phase1ResponseText'
import { AssistantBlocksBody, AssistantDemoBody } from './ChatThreadAssistantDemoBody.jsx'
import outputStyles from './chatThreadAssistantOutput.module.scss'

/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * @param {{ assistant: ChatMessage, onAgentQuestionSelect?: (optionId: string) => void }} props
 */
export default function ChatThreadAssistantMessageBody({ assistant, onAgentQuestionSelect }) {
  const hasPhase1Metadata = Boolean(
    assistant.phase1 ||
      assistant.citations?.length ||
      assistant.activity?.length ||
      assistant.workStatus?.tasks?.length ||
      assistant.memoryIds?.length,
  )
  if (hasPhase1Metadata) {
    return (
      <Box className={outputStyles.agentOutput}>
        <Phase1MessageContent assistant={assistant} onAgentQuestionSelect={onAgentQuestionSelect} />
      </Box>
    )
  }

  const displayBlocks =
    assistant.blocks?.filter(
      (block) => block?.type !== 'agentQuestion' || !assistant.agentQuestion,
    ) ?? []
  if (displayBlocks.length > 0) {
    return (
      <AssistantBlocksBody
        blocks={displayBlocks}
        streaming={Boolean(assistant.demoStreamActive)}
        onAgentQuestionSelect={onAgentQuestionSelect}
      />
    )
  }
  if (assistant.text === 'RESPONSE_COMPONENT_DEMO') return <AssistantDemoBody />

  // Preflight P1: unreachable for production assistant messages — both
  // `phase1StreamPatch` and `conversationMappers` set `phase1: true`. Still
  // reached with the API unconfigured (`runApiCompletionStream` never sets it),
  // where a bare <p> left markdown as literal syntax. Routing it through the
  // same renderer costs nothing and removes that dev-only cliff.
  return (
    <Box className={outputStyles.agentOutput}>
      <Phase1ResponseText text={assistant.text} citations={assistant.citations ?? []} />
    </Box>
  )
}
